import { Cloud, CloudOff, LoaderCircle, TriangleAlert } from "lucide-react";

export type SaveState = "idle" | "dirty" | "saving" | "saved" | "error";

export function SaveIndicator({ state, onRetry }: { state: SaveState; onRetry?: () => void }) {
  const data = {
    idle: [Cloud, "云端内容", "text-muted"],
    dirty: [TriangleAlert, "有未保存修改", "text-warning"],
    saving: [LoaderCircle, "正在保存…", "text-muted"],
    saved: [Cloud, "已保存到云端", "text-success"],
    error: [CloudOff, "未保存", "text-danger"],
  } as const;
  const [Icon, label, tone] = data[state];
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${tone}`} role="status" aria-live="polite">
      <Icon size={15} className={state === "saving" ? "animate-spin" : ""} aria-hidden="true" />{label}
      {state === "error" && onRetry ? <button className="underline" onClick={onRetry}>重试</button> : null}
    </span>
  );
}

export function StatusBadge({ children, tone = "neutral" }: { children: React.ReactNode; tone?: "neutral" | "success" | "warning" | "danger" | "info" }) {
  const styles = {
    neutral: "bg-subtle text-muted",
    success: "bg-[var(--color-success-soft)] text-success",
    warning: "bg-[var(--color-warning-soft)] text-warning",
    danger: "bg-[var(--color-danger-soft)] text-danger",
    info: "bg-[var(--color-info-soft)] text-[var(--color-info)]",
  };
  return <span className={`badge ${styles[tone]}`}>{children}</span>;
}
